/**
 * JS represents application entry point with specification of module dependencies.
 */

// import css and images (important for webpack)
import '../images/icon.ico';
import '../images/icon.png';

import pcLogoCs from '../images/e_shop_cs.png';
import pcLogoEn from '../images/e_shop_en.png';
import localization from './localization';

const header = {
	pc: { logo: pcLogoCs, publicLogo: pcLogoCs, publicLogoEn: pcLogoEn, publicHeight: 50 },
	tablet: { logo: pcLogoCs, publicLogo: pcLogoCs, publicLogoEn: pcLogoEn, publicHeight: 24 },
	mobile: { logo: pcLogoCs, publicLogo: pcLogoCs, publicLogoEn: pcLogoEn, publicHeight: 40 }
};

import Template from './template';
import { init } from 'simplifyworks-core-ui';
import eoc from 'simplifyworks-eoc-ui';
import dynamicFields from 'simplifyworks-dynamic-fields-ui';

let modules = [eoc, dynamicFields];

//import has to be after eoc import to override eoc scss file
import '../css/app.scss';

const eocCustomization = {
	signUpAllowed: true,
	discountCodeAllowed: true,
	fbUrl: 'http://www.facebook.com/Filosoficky.ustav.AVCR',
	ytUrl: 'https://www.youtube.com/user/FilosofickyustavAVCR',
	copyrightFooter: 'Filosofický ústav AV ČR, v. v. i., Jilská 1, 110 00 Praha 1<br />Pro správné fungování e-shopu používáme tzv. technické cookies, které jsou pro užití e-shopu nezbytně nutné a pro jejichž použití není třeba vašeho souhlasu.',
	termsConditionsUrl: { cs: 'https://eshopflu.eis.cas.cz/simplifyworks/eoc/public/info-sections/nakup', en: 'https://eshopflu.eis.cas.cz/simplifyworks/eoc/public/info-sections/nakup' },
	gdprUrl: { cs: 'https://eshopflu.eis.cas.cz/simplifyworks/eoc/public/info-sections/udaje', en: 'https://eshopflu.eis.cas.cz/simplifyworks/eoc/public/info-sections/udaje' },
	productListSettings: {
		hideFilter: true,
		imgWidth: 223,
		imgHeight: 295
	},
	priceDecimals: false,
	currencySelect: ['CZK', 'EUR']
};

// init application with specified modules and customization
init({
	Template,
	systemModules: [],
	modules: modules,
	header,
	customization: {
		defaultPath: '/eoc/public/products',
		localization,
		defaultModuleKey: 'eoc',
		publicForgottenPassword:{
			showBackButton:true
		}
	},
	eocCustomization
});
